import { render, staticRenderFns } from "./CommondityIndex.vue?vue&type=template&id=51e93409&scoped=true&"
import script from "./CommondityIndex.vue?vue&type=script&lang=js&"
export * from "./CommondityIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e93409",
  null
  
)

export default component.exports